import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabaseClient';
import { BACKEND_NODE_URL } from '../config/constants';
import LoadingSpinner from './LoadingSpinner';
import CampaignsPage from './CampaignsPage';
import './ContactsPage.css';
import './CRMContactDetailModal.css';
import './CampaignsPage.css';
import AppIcon from './icons/AppIcon';

// Nesta fase, a página mantém apenas a UI e estado local (com cache em localStorage).

const ContactsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [contacts, setContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailContactId, setDetailContactId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingContactId, setEditingContactId] = useState(null);
  const [newContact, setNewContact] = useState({
    name: '',
    email: '',
    phone: '',
    tag: 'Cliente',
    status: 'Ativo'
  });
  const [connections, setConnections] = useState([]);
  const [selectedConnectionId, setSelectedConnectionId] = useState('');
  const [isEnriching, setIsEnriching] = useState(false);
  const [enrichedData, setEnrichedData] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const [syncChoices, setSyncChoices] = useState({ name: true, email: false, image: true });
  const { user } = useAuth();
  const [loading, setLoading] = useState(true); // Inicia como true
  const [error, setError] = useState(null);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalContacts, setTotalContacts] = useState(0);
  const CONTACTS_PER_PAGE = 100;

  const [detailContact, setDetailContact] = useState(null);
  const [detailForm, setDetailForm] = useState({
    nome: '',
    numero: '',
    email: '',
    tipo: '',
    status: 'Ativo'
  });
  const [savingDetail, setSavingDetail] = useState(false);
  const [detailObservacoes, setDetailObservacoes] = useState('');
  const [savingObservacoes, setSavingObservacoes] = useState(false);
  const [detailConnection, setDetailConnection] = useState(null);
  const [detailConversations, setDetailConversations] = useState([]);
  const [detailMessages, setDetailMessages] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('info');
  const [showNewConversationModal, setShowNewConversationModal] = useState(false);
  const [availableConnections, setAvailableConnections] = useState([]);
  const [selectedNewConnection, setSelectedNewConnection] = useState(null);
  const [creatingConversation, setCreatingConversation] = useState(false);

  // Aba principal da página (contatos vs campanhas)
  const [pageTab, setPageTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('tab') === 'campanhas' ? 'campanhas' : 'contatos';
  });

  const [scheduledEvents, setScheduledEvents] = useState([]);
  const [scheduledLoading, setScheduledLoading] = useState(false);
  const [scheduleEnabled, setScheduleEnabled] = useState(true);
  const [scheduledDateTime, setScheduledDateTime] = useState('');
  const [scheduledMessage, setScheduledMessage] = useState('');
  const [editingScheduleId, setEditingScheduleId] = useState(null);
  const [companyTimezone, setCompanyTimezone] = useState('America/Sao_Paulo');

  const [contactProjectCards, setContactProjectCards] = useState([]);
  const [projectsTabLoading, setProjectsTabLoading] = useState(false);
  const [projectsMap, setProjectsMap] = useState({});
  const [listsMap, setListsMap] = useState({});
  const [availableProjects, setAvailableProjects] = useState([]);
  const [availableProjectLists, setAvailableProjectLists] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [selectedProjectListId, setSelectedProjectListId] = useState('');
  const [projectsActionLoading, setProjectsActionLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [attachmentsLoading, setAttachmentsLoading] = useState(false);
  const [attachmentsUploading, setAttachmentsUploading] = useState(false);
  const [attachmentsSigning, setAttachmentsSigning] = useState(false);

  // Chave de armazenamento local para cache dos contatos
  const CONTACTS_STORAGE_KEY = 'astro_contatos';

  const sanitizeToE164BR = (input) => {
    const raw = String(input || '').replace(/\D/g, '');
    return raw.startsWith('55') ? raw : `55${raw}`;
  };

  const formatFileSize = (value) => {
    if (!value && value !== 0) return '-';
    const size = Number(value);
    if (Number.isNaN(size)) return '-';
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  };

  const handleSaveObservacoes = async () => {
    try {
      if (!detailContactId) return;
      if (savingObservacoes) return;
      setSavingObservacoes(true);
      const { error } = await supabase
        .from('contatos')
        .update({
          observacoes: detailObservacoes || null,
          updated_at: new Date().toISOString()
        })
        .eq('id', detailContactId)
        .eq('company_id', user.company_id);
      if (error) throw error;
      setDetailContact((prev) => ({ ...prev, observacoes: detailObservacoes }));
      alert('Observações salvas com sucesso.');
    } catch (error) {
      console.error('Erro ao salvar observações:', error);
      alert('Erro ao salvar observações: ' + error.message);
    } finally {
      setSavingObservacoes(false);
    }
  };

  const handleRefreshAttachmentUrl = async (attachmentId) => {
    try {
      const attachment = attachments.find((item) => item.id === attachmentId);
      if (!attachment) return;
      const signedUrl = await getSignedAttachmentUrl(attachmentId);
      if (!signedUrl) return;
      setAttachments((prev) => prev.map((item) => (
        item.id === attachmentId ? { ...item, signedUrl } : item
      )));
    } catch (error) {
      console.error('Erro ao gerar link do anexo:', error);
    }
  };

  const getSignedAttachmentUrl = async (attachmentId) => {
    try {
      if (!attachmentId || !user?.company_id) return null;
      setAttachmentsSigning(true);
      const response = await fetch(`${BACKEND_NODE_URL}/contacts/attachments/signed-url`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_id: user.company_id, attachment_id: attachmentId })
      });
      if (!response.ok) return null;
      const data = await response.json();
      return data?.signedUrl || null;
    } catch (error) {
      console.error('Erro ao assinar URL do anexo:', error);
      return null;
    } finally {
      setAttachmentsSigning(false);
    }
  };

  const loadContactAttachments = async () => {
    try {
      if (!detailContactId || !user?.company_id) return;
      setAttachmentsLoading(true);
      const response = await fetch(`${BACKEND_NODE_URL}/contacts/attachments?company_id=${user.company_id}&contact_id=${detailContactId}`);
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.details || payload?.error || 'Falha ao carregar anexos');
      }
      setAttachments(payload?.data || []);
    } catch (error) {
      console.error('Erro ao carregar anexos:', error);
    } finally {
      setAttachmentsLoading(false);
    }
  };

  const handleUploadAttachment = async (event) => {
    try {
      const file = event.target.files?.[0];
      if (!file) return;
      if (!detailContactId || !user?.company_id) return;
      setAttachmentsUploading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('company_id', user.company_id);
      formData.append('contact_id', detailContactId);
      if (user?.id) formData.append('created_by', user.id);

      const response = await fetch(`${BACKEND_NODE_URL}/contacts/attachments/upload`, {
        method: 'POST',
        body: formData
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.details || payload?.error || 'Falha ao enviar anexo');
      }

      setAttachments((prev) => [payload.data, ...prev]);
      event.target.value = '';
    } catch (error) {
      console.error('Erro ao enviar anexo:', error);
      alert('Erro ao enviar anexo: ' + error.message);
    } finally {
      setAttachmentsUploading(false);
    }
  };

  const handleDeleteAttachment = async (attachment) => {
    try {
      if (!attachment?.id) return;
      if (!window.confirm('Remover este anexo?')) return;
      const response = await fetch(`${BACKEND_NODE_URL}/contacts/attachments/${attachment.id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_id: user.company_id })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.details || payload?.error || 'Falha ao remover anexo');
      }
      setAttachments((prev) => prev.filter((item) => item.id !== attachment.id));
    } catch (error) {
      console.error('Erro ao remover anexo:', error);
      alert('Erro ao remover anexo: ' + error.message);
    }
  };

  const handleDetailFieldChange = (field, value) => {
    setDetailForm((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveDetail = async () => {
    try {
      if (!detailContactId) return;
      if (savingDetail) return;
      if (!detailForm.nome?.trim()) {
        alert('Informe o nome do contato.');
        return;
      }
      setSavingDetail(true);
      const payload = {
        nome: detailForm.nome.trim(),
        numero: sanitizeToE164BR(detailForm.numero),
        email: detailForm.email?.trim() || null,
        tipo: detailForm.tipo || null,
        status: detailForm.status || 'Ativo',
        updated_at: new Date().toISOString()
      };
      const { error } = await supabase
        .from('contatos')
        .update(payload)
        .eq('id', detailContactId)
        .eq('company_id', user.company_id);
      if (error) throw error;
      setDetailContact((prev) => ({ ...prev, ...payload }));
      await loadContactsFromSupabase(currentPage);
      alert('Contato atualizado com sucesso.');
    } catch (error) {
      console.error('Erro ao atualizar contato:', error);
      alert('Erro ao atualizar contato: ' + error.message);
    } finally {
      setSavingDetail(false);
    }
  };

  const handleBulkDelete = async () => {
    if (!selectedContacts.length) return;
    if (!window.confirm(`Excluir ${selectedContacts.length} contato(s)? Esta ação não pode ser desfeita.`)) return;
    if (!user?.company_id) {
      alert('Empresa do usuário não encontrada. Faça login novamente.');
      return;
    }
    try {
      setIsBulkDeleting(true);
      const ids = [...selectedContacts];
      const chunkSize = 100;
      
      // ✅ Primeiro, deletar todos os cards do projeto CRM vinculados a estes contatos
      for (let i = 0; i < ids.length; i += chunkSize) {
        const batch = ids.slice(i, i + chunkSize);
        const { error: cardsError } = await supabase
          .from('project_items')
          .delete()
          .in('entity_id', batch)
          .eq('entity_type', 'contact')
          .eq('company_id', user.company_id);
        
        if (cardsError) {
          console.warn('Aviso ao deletar cards dos contatos:', cardsError);
          // Não falha se não conseguir deletar cards, apenas avisa
        }
      }
      
      // ✅ Depois, deletar os contatos
      for (let i = 0; i < ids.length; i += chunkSize) {
        const batch = ids.slice(i, i + chunkSize);
        const { error } = await supabase
          .from('contatos')
          .delete()
          .in('id', batch)
          .eq('company_id', user.company_id);
        if (error) throw error;
      }
      
      await loadContactsFromSupabase(currentPage);
      setSelectedContacts([]);
      alert('Contatos e seus cards no CRM foram excluídos com sucesso!');
    } catch (e) {
      console.error('Erro ao excluir contatos em massa:', e);
      alert(e?.message || 'Erro ao excluir contatos.');
    } finally {
      setIsBulkDeleting(false);
    }
  };

  const getInitials = (name) => {
    try {
      const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
      const first = parts[0] ? parts[0][0] : '';
      const second = parts[1] ? parts[1][0] : '';
      return (first + second).toUpperCase() || 'C';
    } catch (_) { return 'C'; }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    const cleaned = String(phone).replace(/\D/g, '');
    const withoutCountry = cleaned.startsWith('55') ? cleaned.slice(2) : cleaned;
    if (withoutCountry.length === 11) {
      return `(${withoutCountry.slice(0, 2)}) ${withoutCountry.slice(2, 7)}-${withoutCountry.slice(7)}`;
    }
    if (withoutCountry.length === 10) {
      return `(${withoutCountry.slice(0, 2)}) ${withoutCountry.slice(2, 6)}-${withoutCountry.slice(6)}`;
    }
    return phone;
  };

  const formatTimestamp = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleString('pt-BR');
  };

  const formatDateTimeInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16);
  };

  // Carrega conexões para escolher instância/token
  useEffect(() => {
    (async () => {
      try {
        if (!user?.company_id) return;
        const { data, error } = await supabase
          .from('connections')
          .select('id, name, type, status, number')
          .eq('company_id', user.company_id)
          .order('updated_at', { ascending: false });
        if (!error && Array.isArray(data)) {
          setConnections(data);
          const first = data.find(c => String(c?.type).toLowerCase() === 'whatsapp') || data[0];
          if (first?.id) setSelectedConnectionId(first.id);
        }
      } catch (_) {}
    })();
  }, [user?.company_id]);

  useEffect(() => {
    if (isDetailModalOpen && detailContactId) {
      loadDetailData();
      loadCompanyTimezone();
    }
  }, [isDetailModalOpen, detailContactId]);

  useEffect(() => {
    if (activeTab === 'schedule' && detailContactId) {
      loadScheduledEvents();
    }
  }, [activeTab, detailContactId]);

  useEffect(() => {
    if (activeTab === 'projects' && detailContactId) {
      loadContactProjects();
    }
  }, [activeTab, detailContactId]);

  useEffect(() => {
    if (selectedProjectId) {
      loadProjectListsForProject(selectedProjectId);
    } else {
      setAvailableProjectLists([]);
      setSelectedProjectListId('');
    }
  }, [selectedProjectId]);

  useEffect(() => {
    if (showNewConversationModal) {
      loadAvailableConnections();
    }
  }, [showNewConversationModal]);

  // Fluxos de atendimento via n8n removidos nesta fase. O botão de chat foi ocultado.

  const loadContactsFromStorage = () => {
    try {
      const cached = localStorage.getItem(CONTACTS_STORAGE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed)) setContacts(parsed);
      }
    } catch (e) {
      console.warn('Erro ao ler contatos do localStorage:', e);
    }
  };

  const isUUID = (val) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(val || ''));

  const loadContactsFromSupabase = async (page = 1, searchQuery = searchTerm) => {
    if (!user?.company_id) {
      // Se não houver company_id, tenta cache local e sai
      loadContactsFromStorage();
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const searchRaw = String(searchQuery || '').trim();
      if (searchRaw && BACKEND_NODE_URL) {
        const params = new URLSearchParams({
          company_id: user.company_id,
          user_id: user?.id || '',
          q: searchRaw,
          page: String(page),
          page_size: String(CONTACTS_PER_PAGE)
        });
        const authToken = localStorage.getItem('astro_auth_token');
        const response = await fetch(`${BACKEND_NODE_URL.replace(/\/$/, '')}/contacts/search?${params.toString()}`,
          {
            headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined
          }
        );
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || !payload?.ok) {
          throw new Error(payload?.error || 'Falha ao buscar contatos');
        }
        setContacts(payload?.data || []);
        setTotalContacts(Number(payload?.count || 0));
        setCurrentPage(page);
        try { localStorage.setItem(CONTACTS_STORAGE_KEY, JSON.stringify(payload?.data || [])); } catch (_) {}
        return;
      }
      // Calcular offset para paginação
      const offset = (page - 1) * CONTACTS_PER_PAGE;
      
      // Buscar total de contatos
      const { count, error: countError } = await supabase
        .from('contatos')
        .select('*', { count: 'exact', head: true })
        .eq('company_id', user.company_id);
      
      if (countError) throw countError;
      setTotalContacts(count || 0);
      
      // Buscar contatos da página atual com informações de conexão
      const { data, error } = await supabase
        .from('contatos')
        .select(`
          id, 
          company_id, 
          nome, 
          tipo,
          numero, 
          image_url, 
          created_at, 
          updated_at,
          connection_id,
          connections(name)
        `)
        .eq('company_id', user.company_id)
        .order('updated_at', { ascending: false })
        .range(offset, offset + CONTACTS_PER_PAGE - 1);
      
      if (error) throw error;
      
      // Buscar última mensagem de cada contato
      let contactsWithLastMessage = Array.isArray(data) ? data : [];
      
      if (contactsWithLastMessage.length > 0) {
        const contactIds = contactsWithLastMessage.map(c => c.id);
        const { data: messagesData } = await supabase
          .from('conversas')
          .select('contato_id, ultima_mensagem_em')
          .in('contato_id', contactIds)
          .order('ultima_mensagem_em', { ascending: false });
        
        // Mapear última mensagem por contato
        const lastMessageMap = {};
        if (messagesData) {
          messagesData.forEach(conv => {
            if (!lastMessageMap[conv.contato_id] || new Date(conv.ultima_mensagem_em) > new Date(lastMessageMap[conv.contato_id])) {
              lastMessageMap[conv.contato_id] = conv.ultima_mensagem_em;
            }
          });
        }
        
        // Adicionar última mensagem aos contatos
        contactsWithLastMessage = contactsWithLastMessage.map(c => ({
          ...c,
          ultima_mensagem_em: lastMessageMap[c.id] || null
        }));
      }
      
      setContacts(contactsWithLastMessage);
      setCurrentPage(page);
      try { localStorage.setItem(CONTACTS_STORAGE_KEY, JSON.stringify(contactsWithLastMessage)); } catch (_) {}
    } catch (err) {
      console.error('Erro ao carregar contatos do Supabase:', err);
      setError(err.message || 'Falha ao carregar contatos');
      loadContactsFromStorage();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Primeiro tenta carregar do Supabase pelo company_id; caso indisponível, usa cache local
    loadContactsFromSupabase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.company_id]);

  useEffect(() => {
    if (!user?.company_id) return;
    const timer = setTimeout(() => {
      loadContactsFromSupabase(1, searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, user?.company_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewContact(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const normalizeRowsForExport = (rows) => {
    return rows.map((c) => ({
      nome: c.nome || c.name || '',
      email: c.email || '',
      numero: c.numero || c.phone || '',
      created_at: c.created_at || c.criado_em || '',
      updated_at: c.updated_at || c.atualizado_em || ''
    }));
  };

  const getExportSource = () => {
    if (selectedContacts.length > 0) {
      const selected = contacts.filter(c => selectedContacts.includes(c.id));
      return normalizeRowsForExport(selected);
    }
    return normalizeRowsForExport(contacts);
  };

  const handleExportCSV = () => {
    try {
      const rows = getExportSource();
      if (!rows.length) {
        alert('Nenhum contato para exportar.');
        return;
      }
      // Cabeçalhos visíveis e ordem fixa
      const headers = ['nome','email','numero','created_at','updated_at'];
      const headerLabels = ['Nome','Email','Número','Criado em','Atualizado em'];
      const esc = (v) => {
        const s = String(v ?? '');
        if (s.includes('"') || s.includes(',') || s.includes('\n')) {
          return '"' + s.replace(/"/g, '""') + '"';
        }
        return s;
      };
      const lines = [headerLabels.join(',')];
      for (const r of rows) {
        const cells = headers.map((h) => {
          if (h === 'numero') {
            // Forçar Excel a tratar como texto
            const v = String(r[h] ?? '');
            return esc(`="${v}"`);
          }
          return esc(r[h]);
        });
        lines.push(cells.join(','));
      }
      const csv = lines.join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const ts = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 12);
      a.href = url;
      a.download = `contatos-${ts}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Erro ao exportar CSV:', e);
      alert(e?.message || 'Erro ao exportar CSV');
    }
  };

  const handleExportExcel = () => {
    try {
      const rows = getExportSource();
      if (!rows.length) {
        alert('Nenhum contato para exportar.');
        return;
      }
      // Cabeçalhos visíveis e ordem fixa
      const headers = ['nome','email','numero','created_at','updated_at'];
      const headerLabels = ['Nome','Email','Número','Criado em','Atualizado em'];
      const escHtml = (v) => String(v ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const th = headerLabels.map(h => `<th>${escHtml(h)}</th>`).join('');
      const trs = rows.map(r => `<tr>${headers.map(h => {
        const v = escHtml(r[h]);
        if (h === 'numero') {
          return `<td style="mso-number-format:'@'">${v}</td>`;
        }
        return `<td>${v}</td>`;
      }).join('')}</tr>`).join('');
      const table = `<!DOCTYPE html><html><head><meta charset="utf-8" /></head><body><table border="1"><thead><tr>${th}</tr></thead><tbody>${trs}</tbody></table></body></html>`;
      const blob = new Blob([table], { type: 'application/vnd.ms-excel' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const ts = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 12);
      a.href = url;
      a.download = `contatos-${ts}.xls`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Erro ao exportar Excel:', e);
      alert(e?.message || 'Erro ao exportar Excel');
    }
  };

  const handleAddContact = () => {
    // Abre o modal de adicionar contato
    setIsEditing(false);
    setEditingContactId(null);
    setIsAddModalOpen(true);
  };

  const handleCloseModal = () => {
    // Fecha o modal e limpa o formulário
    setIsAddModalOpen(false);
    setIsEditing(false);
    setEditingContactId(null);
    setNewContact({
      name: '',
      email: '',
      phone: '',
      tag: 'Cliente',
      status: 'Ativo'
    });
    setEnrichedData(null);
    setSyncChoices({ name: true, email: false, image: true });
  };

  const handleOpenDetailModal = (contactId) => {
    if (!contactId) return;
    setDetailContactId(contactId);
    setIsDetailModalOpen(true);
    setActiveTab('info');
  };

  useEffect(() => {
    try {
      const contactId = location?.state?.openContactId;
      if (!contactId) return;
      handleOpenDetailModal(contactId);
      navigate('/contatos', { replace: true, state: {} });
    } catch (_) {}
  }, [location?.state?.openContactId]);

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setDetailContactId(null);
    setDetailContact(null);
    setDetailForm({ nome: '', numero: '', email: '', tipo: '', status: 'Ativo' });
    setSavingDetail(false);
    setDetailObservacoes('');
    setSavingObservacoes(false);
    setDetailConnection(null);
    setDetailConversations([]);
    setDetailMessages([]);
    setSelectedConversation(null);
    setActiveTab('info');
    setScheduledEvents([]);
    setScheduledLoading(false);
    setScheduleEnabled(true);
    setScheduledDateTime('');
    setScheduledMessage('');
    setEditingScheduleId(null);
    setContactProjectCards([]);
    setProjectsMap({});
    setListsMap({});
    setAvailableProjects([]);
    setAvailableProjectLists([]);
    setSelectedProjectId('');
    setSelectedProjectListId('');
    setShowNewConversationModal(false);
    setSelectedNewConnection(null);
    setAttachments([]);
    setAttachmentsLoading(false);
    setAttachmentsUploading(false);
    setAttachmentsSigning(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    try {
      setIsSaving(true);
      if (!user?.id || !user?.company_id) {
        throw new Error('Usuário ou empresa não definidos. Faça login novamente.');
      }

      const base = {
        nome: newContact.name?.trim() || '',
        numero: sanitizeToE164BR(newContact.phone),
        email: newContact.email?.trim() || null,
        tag: newContact.tag || null,
        status: newContact.status || 'Ativo',
        fonte_do_contato: 'manual',
        canal: 'whatsapp',
        updated_at: new Date().toISOString(),
      };

      if (isEditing && editingContactId && isUUID(editingContactId)) {
        // Update no Supabase
        const { error } = await supabase
          .from('contatos')
          .update(base)
          .eq('id', editingContactId)
          .eq('company_id', user.company_id);
        if (error) throw error;
      } else {
        // Insert no Supabase
        const insertPayload = {
          owner_id: user.id,
          company_id: user.company_id,
          ...base,
        };
        const { data, error } = await supabase
          .from('contatos')
          .insert(insertPayload)
          .select('id, owner_id, company_id, nome, email, numero, tag, canal, fonte_do_contato, status, created_at, updated_at')
          .single();
        if (error) throw error;
      }

      // Recarrega lista do Supabase para manter em sincronia
      await loadContactsFromSupabase(currentPage);
      handleCloseModal();
    } catch (err) {
      console.error('Erro ao salvar contato no Supabase:', err);
      alert(err.message || 'Erro ao salvar contato');
    } finally {
      setIsSaving(false);
    }
  };

  const handleEditContact = (contactId) => {
    handleOpenDetailModal(contactId);
  };

  const loadDetailData = async () => {
    try {
      if (!detailContactId) return;
      setDetailLoading(true);
      const { data: contactData, error: contactError } = await supabase
        .from('contatos')
        .select('*')
        .eq('id', detailContactId)
        .single();

      if (contactError) throw contactError;
      setDetailContact(contactData);
      setDetailForm({
        nome: contactData?.nome || '',
        numero: contactData?.numero || '',
        email: contactData?.email || '',
        tipo: contactData?.tipo || '',
        status: contactData?.status || 'Ativo'
      });
      setDetailObservacoes(contactData?.observacoes || '');

      const { data: conversasData } = await supabase
        .from('conversas')
        .select('*')
        .eq('contato_id', detailContactId)
        .order('atualizado_em', { ascending: false });

      setDetailConversations(conversasData || []);

      if (contactData?.connection_id) {
        const { data: connectionData } = await supabase
          .from('connections')
          .select('name, type')
          .eq('id', contactData.connection_id)
          .single();
        setDetailConnection(connectionData || null);
      } else {
        setDetailConnection(null);
      }

      if (conversasData && conversasData.length > 0) {
        setSelectedConversation(conversasData[0]);
        loadMessages(conversasData[0].id);
      } else {
        setSelectedConversation(null);
        setDetailMessages([]);
      }

      await loadContactAttachments();
    } catch (error) {
      console.error('Erro ao carregar detalhes do contato:', error);
    } finally {
      setDetailLoading(false);
    }
  };

  const loadMessages = async (conversationId) => {
    try {
      if (!conversationId) return;
      const { data: messagesData, error } = await supabase
        .from('mensagens')
        .select('id, conteudo, tipo_conteudo, direcao, from_me, criado_em, url_midia, transcricao, metadados')
        .eq('conversa_id', conversationId)
        .order('criado_em', { ascending: false })
        .limit(10);

      if (error) throw error;
      setDetailMessages((messagesData || []).reverse());
    } catch (error) {
      console.error('Erro ao carregar mensagens:', error);
    }
  };

  const loadCompanyTimezone = async () => {
    try {
      const companyId = user?.company_id;
      if (!companyId) return;
      const { data, error } = await supabase
        .from('configuracoes_empresa')
        .select('timezone')
        .eq('company_id', companyId)
        .single();
      if (error) throw error;
      setCompanyTimezone(data?.timezone || 'America/Sao_Paulo');
    } catch (_) {
      setCompanyTimezone('America/Sao_Paulo');
    }
  };

  const loadScheduledEvents = async () => {
    try {
      setScheduledLoading(true);
      const companyId = user?.company_id;
      if (!companyId || !detailContactId) return;
      const { data, error } = await supabase
        .from('calendar_events')
        .select('*')
        .eq('company_id', companyId)
        .contains('participants', [{ type: 'contact', id: detailContactId }])
        .eq('event_type', 'crm_scheduled_message')
        .eq('is_deleted', false)
        .order('start_date', { ascending: false });
      if (error) throw error;
      setScheduledEvents(data || []);
    } catch (error) {
      console.error('Erro ao carregar agendamentos:', error);
    } finally {
      setScheduledLoading(false);
    }
  };

  const handleSaveSchedule = async () => {
    try {
      if (!scheduleEnabled) return;
      if (!scheduledDateTime) {
        alert('Selecione data e hora');
        return;
      }
      if (!scheduledMessage.trim()) {
        alert('Digite a mensagem');
        return;
      }

      const companyId = user?.company_id;
      if (!companyId) {
        alert('Empresa nao encontrada. Atualize a pagina e tente novamente.');
        return;
      }
      const startDate = new Date(scheduledDateTime).toISOString();
      const title = `CRM: Mensagem agendada para ${detailContact?.nome || detailContact?.numero || 'Contato'}`;
      const basePayload = {
        company_id: companyId,
        title,
        description: scheduledMessage,
        start_date: startDate,
        end_date: startDate,
        all_day: false,
        timezone: companyTimezone || 'America/Sao_Paulo',
        event_type: 'crm_scheduled_message',
        status: 'scheduled',
        organizer_id: user?.id || null,
        participants: [
          {
            type: 'contact',
            id: detailContactId,
            name: detailContact?.nome || 'Contato'
          }
        ],
        custom_fields: {
          message_text: scheduledMessage,
          contact_id: detailContactId,
          contact_number: detailContact?.numero || null,
          channel: 'whatsapp',
          source: 'contacts_modal'
        },
        updated_by: user?.id || null,
      };

      if (editingScheduleId) {
        const { error } = await supabase
          .from('calendar_events')
          .update({
            ...basePayload,
            updated_at: new Date().toISOString()
          })
          .eq('id', editingScheduleId);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('calendar_events')
          .insert({
            ...basePayload,
            created_by: user?.id || null
          });
        if (error) throw error;
      }

      setScheduledDateTime('');
      setScheduledMessage('');
      setEditingScheduleId(null);
      await loadScheduledEvents();
      alert('Agendamento salvo!');
    } catch (error) {
      console.error('Erro ao salvar agendamento:', error);
      alert('Erro ao salvar agendamento: ' + error.message);
    }
  };

  const handleEditSchedule = (event) => {
    setEditingScheduleId(event.id);
    setScheduledDateTime(formatDateTimeInput(event.start_date));
    setScheduledMessage(event.custom_fields?.message_text || event.description || '');
    setScheduleEnabled(true);
  };

  const handleCancelSchedule = async (eventId) => {
    try {
      const { error } = await supabase
        .from('calendar_events')
        .update({ status: 'canceled', updated_at: new Date().toISOString() })
        .eq('id', eventId);
      if (error) throw error;
      await loadScheduledEvents();
    } catch (error) {
      console.error('Erro ao cancelar agendamento:', error);
      alert('Erro ao cancelar agendamento: ' + error.message);
    }
  };

  const loadContactProjects = async () => {
    try {
      setProjectsTabLoading(true);
      const companyId = user?.company_id;
      if (!companyId || !detailContactId) return;
      const { data: cardsData, error: cardsError } = await supabase
        .from('project_items')
        .select('id, project_id, list_id, title, status, created_at, updated_at')
        .eq('company_id', companyId)
        .eq('entity_type', 'contact')
        .eq('entity_id', detailContactId);
      if (cardsError) throw cardsError;
      const cards = cardsData || [];
      setContactProjectCards(cards);

      const projectIds = [...new Set(cards.map(item => item.project_id).filter(Boolean))];
      if (projectIds.length > 0) {
        const { data: projectsData, error: projectsError } = await supabase
          .from('projects')
          .select('id, name, color, project_type')
          .in('id', projectIds);
        if (projectsError) throw projectsError;
        const map = (projectsData || []).reduce((acc, projectRow) => {
          acc[projectRow.id] = projectRow;
          return acc;
        }, {});
        setProjectsMap(map);

        const { data: listsData, error: listsError } = await supabase
          .from('project_lists')
          .select('id, name, icon, color, project_id')
          .in('project_id', projectIds);
        if (listsError) throw listsError;
        const listMap = (listsData || []).reduce((acc, listRow) => {
          acc[listRow.id] = listRow;
          return acc;
        }, {});
        setListsMap(listMap);
      } else {
        setProjectsMap({});
        setListsMap({});
      }

      const { data: availableData, error: availableError } = await supabase
        .from('projects')
        .select('id, name, project_type')
        .eq('company_id', companyId)
        .order('name', { ascending: true });
      if (availableError) throw availableError;
      setAvailableProjects(availableData || []);
    } catch (error) {
      console.error('Erro ao carregar projetos do contato:', error);
    } finally {
      setProjectsTabLoading(false);
    }
  };

  const loadProjectListsForProject = async (targetProjectId) => {
    try {
      const { data, error } = await supabase
        .from('project_lists')
        .select('id, name, icon, color')
        .eq('project_id', targetProjectId)
        .order('name', { ascending: true });
      if (error) throw error;
      setAvailableProjectLists(data || []);
      if (!data?.some(list => list.id === selectedProjectListId)) {
        setSelectedProjectListId('');
      }
    } catch (error) {
      console.error('Erro ao carregar listas do projeto:', error);
      setAvailableProjectLists([]);
    }
  };

  const handleAddToProject = async () => {
    try {
      if (!selectedProjectId || !selectedProjectListId) {
        alert('Selecione um projeto e uma lista.');
        return;
      }
      const companyId = user?.company_id;
      if (!companyId) return;
      setProjectsActionLoading(true);

      const { data: existingCard, error: checkError } = await supabase
        .from('project_items')
        .select('id, list_id')
        .eq('project_id', selectedProjectId)
        .eq('company_id', companyId)
        .eq('entity_type', 'contact')
        .eq('entity_id', detailContactId)
        .maybeSingle();
      if (checkError) throw checkError;
      if (existingCard) {
        alert('Este contato já existe no projeto selecionado.');
        return;
      }

      const { error } = await supabase
        .from('project_items')
        .insert({
          list_id: selectedProjectListId,
          project_id: selectedProjectId,
          company_id: companyId,
          entity_type: 'contact',
          entity_id: detailContactId,
          title: detailContact?.nome || detailContact?.numero || 'Contato',
          description: `Contato adicionado via modal em ${new Date().toLocaleString('pt-BR')}`,
          display_order: 0,
          list_entered_at: new Date().toISOString(),
          status: 'active',
          priority: 'normal',
          metadata: {
            source: 'contacts_modal'
          }
        });
      if (error) throw error;
      await loadContactProjects();
    } catch (error) {
      console.error('Erro ao adicionar contato ao projeto:', error);
      alert('Erro ao adicionar contato ao projeto: ' + error.message);
    } finally {
      setProjectsActionLoading(false);
    }
  };

  const handleMoveToProject = async () => {
    try {
      if (!selectedProjectId || !selectedProjectListId) {
        alert('Selecione um projeto e uma lista.');
        return;
      }
      const companyId = user?.company_id;
      if (!companyId) return;
      setProjectsActionLoading(true);

      const { data: existingCard, error: checkError } = await supabase
        .from('project_items')
        .select('id, list_id')
        .eq('project_id', selectedProjectId)
        .eq('company_id', companyId)
        .eq('entity_type', 'contact')
        .eq('entity_id', detailContactId)
        .maybeSingle();
      if (checkError) throw checkError;

      if (!existingCard) {
        await handleAddToProject();
        return;
      }

      const { error } = await supabase
        .from('project_items')
        .update({ list_id: selectedProjectListId })
        .eq('id', existingCard.id);
      if (error) throw error;
      await loadContactProjects();
    } catch (error) {
      console.error('Erro ao mover contato no projeto:', error);
      alert('Erro ao mover contato no projeto: ' + error.message);
    } finally {
      setProjectsActionLoading(false);
    }
  };

  const loadAvailableConnections = async () => {
    try {
      if (!user?.company_id) return;
      const { data, error } = await supabase
        .from('connections')
        .select('id, name, type, external_instance_token')
        .eq('company_id', user.company_id)
        .eq('type', 'whatsapp')
        .order('updated_at', { ascending: false });
      if (error) throw error;
      setAvailableConnections(data || []);
    } catch (error) {
      console.error('Erro ao carregar conexoes:', error);
      setAvailableConnections([]);
    }
  };

  const handleStartNewConversation = async () => {
    if (!selectedNewConnection) {
      alert('Selecione uma conexão');
      return;
    }
    try {
      setCreatingConversation(true);
      const { data: session } = await supabase.auth.getSession();
      const response = await fetch('/api/conversations/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${session?.session?.access_token || ''}`
        },
        body: JSON.stringify({
          company_id: user?.company_id,
          contato_id: detailContactId,
          connection_id: selectedNewConnection.id,
          contact_number: detailContact?.numero
        })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'Erro ao criar conversa');
      navigate(`/atendimentos?conversa_id=${result.conversa_id}`);
      handleCloseDetailModal();
    } catch (error) {
      console.error('Erro ao criar conversa:', error);
      alert('Erro ao criar conversa: ' + error.message);
    } finally {
      setCreatingConversation(false);
    }
  };

  const getApiBase = () => {
    const env = import.meta?.env?.VITE_API_BASE_URL;
    if (env) return env.replace(/\/$/, '');
    try {
      const { origin } = window.location;
      if (origin.includes('//app.')) return origin.replace('//app.', '//api.');
      return origin; // fallback mesmo host
    } catch (_) { return ''; }
  };

  const getAdminToken = () => {
    return localStorage.getItem('admin_token') || import.meta?.env?.VITE_ADMIN_ACCESS_TOKEN || '';
  };

  const handleEnrichContact = async () => {
    try {
      if (isEnriching) return;
      const number = sanitizeToE164BR(newContact.phone);
      if (!number) {
        alert('Número inválido para atualizar contato.');
        return;
      }
      if (!selectedConnectionId) {
        alert('Selecione uma conexão para obter os detalhes.');
        return;
      }
      setIsEnriching(true);
      const API_BASE = getApiBase();
      const url = `${API_BASE}/admin/uazapi/chat-details?number=${encodeURIComponent(number)}&connection_id=${encodeURIComponent(selectedConnectionId)}&preview=false`;
      const resp = await fetch(url, {
        method: 'GET',
        headers: {
          'X-Admin-Token': getAdminToken()
        }
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || !data?.ok) {
        throw new Error(data?.error || `Falha ao buscar detalhes (${resp.status})`);
      }
      setEnrichedData(data?.data || null);
    } catch (err) {
      console.error('Erro ao obter detalhes do contato:', err);
      alert(err.message || 'Erro ao obter detalhes do contato');
    } finally {
      setIsEnriching(false);
    }
  };

  const handleSyncContact = async () => {
    try {
      if (syncing) return;
      if (!editingContactId) return;
      if (!enrichedData) {
        alert('Nenhum dado atualizado para sincronizar. Use "Atualizar contato" primeiro.');
        return;
      }
      const patch = {};
      if (syncChoices.name) {
        patch.nome = enrichedData.wa_contactName || enrichedData.wa_name || enrichedData.name || null;
      }
      if (syncChoices.email) {
        patch.email = enrichedData.lead_email || null;
      }
      if (syncChoices.image) {
        patch.image_url = enrichedData.image || enrichedData.imagePreview || null;
      }
      if (!Object.keys(patch).length) {
        alert('Nenhum campo selecionado para sincronizar.');
        return;
      }
      setSyncing(true);
      const API_BASE = getApiBase();
      const resp = await fetch(`${API_BASE}/admin/contacts/sync`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Admin-Token': getAdminToken()
        },
        body: JSON.stringify({ contact_id: editingContactId, patch })
      });
      const out = await resp.json().catch(() => ({}));
      if (!resp.ok || !out?.ok) throw new Error(out?.error || 'Falha ao sincronizar contato');
      await loadContactsFromSupabase(currentPage);
      alert('Contato sincronizado com sucesso.');
    } catch (err) {
      console.error('Erro ao sincronizar contato:', err);
      alert(err.message || 'Erro ao sincronizar contato');
    } finally {
      setSyncing(false);
    }
  };

  const handleDeleteContact = async (contactId) => {
    if (!contactId) {
      alert('ID do contato inválido');
      return;
    }
    if (!window.confirm('Tem certeza que deseja excluir este contato? Esta ação não pode ser desfeita.')) {
      return;
    }
    if (!user?.company_id) {
      alert('Empresa do usuário não encontrada. Faça login novamente.');
      return;
    }
    try {
      // ✅ Primeiro, deletar todos os cards do projeto CRM vinculados a este contato
      const { error: cardsError } = await supabase
        .from('project_items')
        .delete()
        .eq('entity_id', contactId)
        .eq('entity_type', 'contact')
        .eq('company_id', user.company_id);
      
      if (cardsError) {
        console.warn('Aviso ao deletar cards do contato:', cardsError);
        // Não falha se não conseguir deletar cards, apenas avisa
      }

      // ✅ Depois, deletar o contato
      const { error } = await supabase
        .from('contatos')
        .delete()
        .eq('id', contactId)
        .eq('company_id', user.company_id);
      if (error) throw error;

      // Recarrega do Supabase para manter sincronizado
      await loadContactsFromSupabase(currentPage);
      alert('Contato e seus cards no CRM foram excluídos com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir contato no Supabase:', error);
      alert(error.message || 'Erro ao excluir contato.');
    }
  };

  const handleSelectContact = (contactId) => {
    // Lógica para selecionar contato
    setSelectedContacts(prev => 
      prev.includes(contactId) 
        ? prev.filter(id => id !== contactId) 
        : [...prev, contactId]
    );
  };

  const filteredContacts = contacts;

  if (loading && contacts.length === 0 && pageTab === 'contatos') {
    return (
      <div className="contacts-page">
        <div className="contacts-page-tabs">
          <button className={`contacts-page-tab ${pageTab === 'contatos' ? 'active' : ''}`} onClick={() => setPageTab('contatos')}>
            <AppIcon name="contacts" />
            Contatos
          </button>
          <button className={`contacts-page-tab ${pageTab === 'campanhas' ? 'active' : ''}`} onClick={() => setPageTab('campanhas')}>
            <AppIcon name="campaign" />
            Campanhas
          </button>
        </div>
        <LoadingSpinner message="Carregando contatos..." />
      </div>
    );
  }

  return (
    <div className="contacts-page">
      {/* Abas superiores */}
      <div className="contacts-page-tabs">
        <button className={`contacts-page-tab ${pageTab === 'contatos' ? 'active' : ''}`} onClick={() => setPageTab('contatos')}>
          <AppIcon name="contacts" />
          Contatos
        </button>
        <button className={`contacts-page-tab ${pageTab === 'campanhas' ? 'active' : ''}`} onClick={() => setPageTab('campanhas')}>
          <AppIcon name="campaign" />
          Campanhas
        </button>
      </div>

      {/* Conteúdo da aba Campanhas */}
      {pageTab === 'campanhas' && <CampaignsPage />}

      {/* Conteúdo da aba Contatos */}
      {pageTab === 'contatos' && (
      <>
      <div className="contacts-header">
        <div className="contacts-toolbar">
          <div className="search-container">
            <input
              type="text"
              placeholder="Pesquisar contatos..."
              value={searchTerm}
              onChange={handleSearch}
              className="search-input"
            />
          </div>
          <button className="add-contact-btn" onClick={handleAddContact}>
            <span className="plus-icon">+</span>
            <span>Adicionar Contato</span>
          </button>
        </div>
      </div>
      
      <div className="contacts-list">
        {filteredContacts.length === 0 ? (
          <div className="empty-state" style={{ padding: '2rem', textAlign: 'center' }}>
            Nenhum contato na sua lista
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th className="checkbox-cell">
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedContacts(contacts.map(c => c.id));
                      } else {
                        setSelectedContacts([]);
                      }
                    }}
                  />
                </th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Whatsapp</th>
                <th>Entrada</th>
                <th className="last-contact-header">Último contato</th>
                <th className="actions-cell">Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredContacts.map(contact => (
                <tr key={contact.id}>
                  <td className="checkbox-cell">
                    <input
                      type="checkbox"
                      checked={selectedContacts.includes(contact.id)}
                      onChange={() => handleSelectContact(contact.id)}
                    />
                  </td>
                  <td>
                    <div>
                      <span className="cell-label">Nome</span>
                      <span className="cell-value">{contact.nome || contact.name}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <span className="cell-label">Tipo</span>
                      <span className="cell-value">{contact.tipo || '-'}</span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <span className="cell-label">Whatsapp</span>
                      <span className="cell-value">
                        {contact.numero || contact.phone}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <span className="cell-label">Entrada</span>
                      <span className="cell-value">
                        {contact.connections?.name || '-'}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <span className="cell-label">Último contato</span>
                      <span className="cell-value">
                        {(contact.ultima_mensagem_em || contact.updated_at)
                          ? new Date(contact.ultima_mensagem_em || contact.updated_at).toLocaleString('pt-BR', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: false
                            }).replace(',', ' -')
                          : '-'}
                      </span>
                    </div>
                  </td>
                  <td className="actions-cell">
                    <div className="actions-container">
                      <span className="cell-label">Ações</span>
                      <div className="action-buttons">
                        {/* Botão de atendimento removido temporariamente (migração para Supabase) */}
                        <div className="action-btn-container">
                          <button 
                            className="action-btn edit-btn"
                            onClick={() => handleEditContact(contact.id)}
                            title="Editar"
                          >
                            <AppIcon name="edit" />
                          </button>
                        </div>
                        <div className="action-btn-container">
                          <button 
                            className="action-btn delete-btn"
                            onClick={() => handleDeleteContact(contact.id)}
                            title="Deletar"
                          >
                            <AppIcon name="delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Paginação */}
      {totalContacts > CONTACTS_PER_PAGE && (
        <div className="pagination" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '1.5rem 0',
          marginTop: '1rem',
          borderTop: '1px solid rgba(49, 117, 177, 0.2)',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => loadContactsFromSupabase(currentPage - 1)}
            disabled={currentPage === 1 || loading}
            className="pagination-btn"
            style={{
              padding: '0.5rem 1rem',
              background: currentPage === 1 ? 'rgba(255,255,255,0.05)' : 'linear-gradient(135deg, #3175b1, #2a5f8f)',
              border: '1px solid rgba(49, 117, 177, 0.35)',
              borderRadius: '8px',
              color: currentPage === 1 ? 'rgba(255,255,255,0.3)' : '#ffffff',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              fontWeight: 500,
              transition: 'all 0.3s ease',
              boxShadow: currentPage === 1 ? 'none' : '0 2px 8px rgba(49, 117, 177, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (currentPage !== 1) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(49, 117, 177, 0.3)';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = currentPage === 1 ? 'none' : '0 2px 8px rgba(49, 117, 177, 0.2)';
            }}
          >
            ← Anterior
          </button>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            color: 'var(--text-color)',
            fontSize: '0.9rem'
          }}>
            <span>Página</span>
            <input
              type="number"
              min="1"
              max={Math.ceil(totalContacts / CONTACTS_PER_PAGE)}
              value={currentPage}
              onChange={(e) => {
                const page = parseInt(e.target.value, 10);
                const maxPage = Math.ceil(totalContacts / CONTACTS_PER_PAGE);
                if (page >= 1 && page <= maxPage) {
                  loadContactsFromSupabase(page);
                }
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  const page = parseInt(e.target.value, 10);
                  const maxPage = Math.ceil(totalContacts / CONTACTS_PER_PAGE);
                  if (page >= 1 && page <= maxPage) {
                    loadContactsFromSupabase(page);
                  }
                }
              }}
              style={{
                width: '60px',
                padding: '0.4rem 0.6rem',
                background: 'rgba(255,255,255,0.05)',
                border: '1px solid rgba(49, 117, 177, 0.35)',
                borderRadius: '6px',
                color: 'var(--primary-color)',
                fontWeight: 600,
                fontSize: '0.95rem',
                textAlign: 'center',
                transition: 'all 0.2s ease'
              }}
            />
            <span>de</span>
            <strong style={{ color: 'var(--primary-color)' }}>{Math.ceil(totalContacts / CONTACTS_PER_PAGE)}</strong>
            <span style={{ marginLeft: '0.25rem', opacity: 0.7 }}>
              ({totalContacts} contatos)
            </span>
          </div>
          
          <button
            onClick={() => loadContactsFromSupabase(currentPage + 1)}
            disabled={currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) || loading}
            className="pagination-btn"
            style={{
              padding: '0.5rem 1rem',
              background: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'rgba(255,255,255,0.05)' : 'linear-gradient(135deg, #3175b1, #2a5f8f)',
              border: '1px solid rgba(49, 117, 177, 0.35)',
              borderRadius: '8px',
              color: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'rgba(255,255,255,0.3)' : '#ffffff',
              cursor: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'not-allowed' : 'pointer',
              fontWeight: 500,
              transition: 'all 0.3s ease',
              boxShadow: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'none' : '0 2px 8px rgba(49, 117, 177, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (currentPage < Math.ceil(totalContacts / CONTACTS_PER_PAGE)) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(49, 117, 177, 0.3)';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'none' : '0 2px 8px rgba(49, 117, 177, 0.2)';
            }}
          >
            Próxima →
          </button>

          <button
            onClick={() => loadContactsFromSupabase(Math.ceil(totalContacts / CONTACTS_PER_PAGE))}
            disabled={currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) || loading}
            className="pagination-btn"
            style={{
              padding: '0.5rem 1rem',
              background: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'rgba(255,255,255,0.05)' : 'linear-gradient(135deg, #3175b1, #2a5f8f)',
              border: '1px solid rgba(49, 117, 177, 0.35)',
              borderRadius: '8px',
              color: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'rgba(255,255,255,0.3)' : '#ffffff',
              cursor: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'not-allowed' : 'pointer',
              fontWeight: 500,
              transition: 'all 0.3s ease',
              boxShadow: currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'none' : '0 2px 8px rgba(49, 117, 177, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (currentPage < Math.ceil(totalContacts / CONTACTS_PER_PAGE)) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(49, 117, 177, 0.3)';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = currentPage >= Math.ceil(totalContacts / CONTACTS_PER_PAGE) ? 'none' : '0 2px 8px rgba(49, 117, 177, 0.2)';
            }}
          >
            Última ⇥
          </button>
        </div>
      )}
      
      {selectedContacts.length > 0 && (
        <div className="bulk-actions">
          <span>{selectedContacts.length} contato(s) selecionado(s)</span>
          <button className="bulk-action-btn" onClick={handleExportCSV}>Exportar CSV</button>
          <button className="bulk-action-btn" onClick={handleExportExcel}>Exportar Excel</button>
          <button className="bulk-action-btn delete-btn" onClick={handleBulkDelete} disabled={isBulkDeleting}>
            {isBulkDeleting ? 'Excluindo...' : 'Deletar'}
          </button>
        </div>
      )}

      {isDetailModalOpen && (
        <div className="modal-overlay" onClick={handleCloseDetailModal}>
          <div className={`crm-contact-detail-modal ${detailLoading ? 'loading' : ''}`} onClick={(e) => e.stopPropagation()}>
            {detailLoading ? (
              <div className="loading-spinner">
                <AppIcon name="progress_activity" className="spinning" />
                <p>Carregando detalhes...</p>
              </div>
            ) : (
              <>
                <div className="modal-header">
                  <div className="contact-header-info">
                    <div className="contact-avatar-large">
                      {detailContact?.image_url ? (
                        <img src={detailContact.image_url} alt="contato" />
                      ) : (
                        <AppIcon name="person" />
                      )}
                    </div>
                    <div className="contact-details">
                      <h2>{detailContact?.nome || 'Contato'}</h2>
                      <div className="contact-badges">
                        {detailConnection && (
                          <span className="badge whatsapp">
                            <AppIcon name="link" />
                            {detailConnection.name}
                          </span>
                        )}
                        {detailContact?.status && (
                          <span className="badge success">
                            <AppIcon name="check_circle" />
                            {detailContact.status}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="contact-header-actions">
                    <div className="contact-phone-inline">
                      <img
                        src="/assets/images/icones/whatsapp-logo-whatsapp-icon-whatsapp-transparent-free-png.webp"
                        alt="WhatsApp"
                        className="contact-phone-icon"
                      />
                      {formatPhoneNumber(detailContact?.numero)}
                    </div>
                    <button className="btn-close" onClick={handleCloseDetailModal}>
                      <AppIcon name="close" />
                    </button>
                  </div>
                </div>

                <div className="modal-tabs">
                  <button
                    className={`tab ${activeTab === 'info' ? 'active' : ''}`}
                    onClick={() => setActiveTab('info')}
                  >
                    <AppIcon name="info" />
                    Informações
                  </button>
                  <button
                    className={`tab ${activeTab === 'messages' ? 'active' : ''}`}
                    onClick={() => setActiveTab('messages')}
                  >
                    <AppIcon name="chat" />
                    Mensagens ({detailMessages.length})
                  </button>
                  <button
                    className={`tab ${activeTab === 'schedule' ? 'active' : ''}`}
                    onClick={() => setActiveTab('schedule')}
                  >
                    <AppIcon name="schedule_send" />
                    Agendar Mensagem
                  </button>
                  <button
                    className={`tab ${activeTab === 'projects' ? 'active' : ''}`}
                    onClick={() => setActiveTab('projects')}
                  >
                    <AppIcon name="workspaces" />
                    Projetos
                  </button>
                  <button
                    className={`tab ${activeTab === 'notes' ? 'active' : ''}`}
                    onClick={() => setActiveTab('notes')}
                  >
                    <AppIcon name="edit_note" />
                    Observações
                  </button>
                  <button
                    className={`tab ${activeTab === 'attachments' ? 'active' : ''}`}
                    onClick={() => setActiveTab('attachments')}
                  >
                    <AppIcon name="attach_file" />
                    Anexos
                  </button>
                </div>

                <div className="modal-content">
                  {activeTab === 'info' && (
                    <div className="tab-content">
                      <div className="info-section">
                        <h3>Dados do Contato</h3>
                        <div className="info-grid">
                          <div className="info-item">
                            <AppIcon name="person" />
                            <div>
                              <label>Nome</label>
                              <input
                                type="text"
                                value={detailForm.nome}
                                onChange={(e) => handleDetailFieldChange('nome', e.target.value)}
                                placeholder="Nome do contato"
                              />
                            </div>
                          </div>
                          <div className="info-item">
                            <AppIcon name="phone" />
                            <div>
                              <label>Telefone</label>
                              <input
                                type="text"
                                value={detailForm.numero}
                                onChange={(e) => handleDetailFieldChange('numero', e.target.value)}
                                placeholder="(00) 00000-0000"
                              />
                            </div>
                          </div>
                          <div className="info-item">
                            <AppIcon name="mail" />
                            <div>
                              <label>E-mail</label>
                              <input
                                type="email"
                                value={detailForm.email}
                                onChange={(e) => handleDetailFieldChange('email', e.target.value)}
                                placeholder="email@dominio.com"
                              />
                            </div>
                          </div>
                          <div className="info-item">
                            <AppIcon name="category" />
                            <div>
                              <label>Tipo</label>
                              <input
                                type="text"
                                value={detailForm.tipo}
                                onChange={(e) => handleDetailFieldChange('tipo', e.target.value)}
                                placeholder="Ex: Cliente"
                              />
                            </div>
                          </div>
                          <div className="info-item">
                            <AppIcon name="flag" />
                            <div>
                              <label>Status</label>
                              <select
                                value={detailForm.status}
                                onChange={(e) => handleDetailFieldChange('status', e.target.value)}
                              >
                                <option value="Ativo">Ativo</option>
                                <option value="Inativo">Inativo</option>
                                <option value="Bloqueado">Bloqueado</option>
                              </select>
                            </div>
                          </div>
                          <div className="info-item">
                            <AppIcon name="info" />
                            <div>
                              <label>Canal</label>
                              <p>{detailContact?.canal || '-'}</p>
                            </div>
                          </div>
                          <div className="info-item">
                            <AppIcon name="source" />
                            <div>
                              <label>Fonte do contato</label>
                              <p>{detailConnection ? `${detailConnection.name} (${detailConnection.type})` : '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="info-actions">
                          <button
                            className="btn-primary"
                            onClick={handleSaveDetail}
                            disabled={savingDetail}
                          >
                            {savingDetail ? 'Salvando...' : 'Salvar alterações'}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === 'messages' && (
                    <div className="tab-content messages-tab">
                      {detailConversations.length > 1 && (
                        <div className="conversation-selector">
                          <label>Conversa:</label>
                          <select
                            value={selectedConversation?.id || ''}
                            onChange={(e) => {
                              const conv = detailConversations.find(c => c.id === e.target.value);
                              setSelectedConversation(conv);
                              if (conv) loadMessages(conv.id);
                            }}
                          >
                            {detailConversations.map(conv => (
                              <option key={conv.id} value={conv.id}>
                                {conv.canal || 'WhatsApp'} - {formatTimestamp(conv.criado_em)}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      <div className="messages-container">
                        {detailMessages.length === 0 ? (
                          <div className="empty-state">
                            <AppIcon name="chat_bubble_outline" />
                            <p>Nenhuma mensagem encontrada</p>
                          </div>
                        ) : (
                          detailMessages.map(msg => (
                            <div
                              key={msg.id}
                              className={`message ${msg.from_me ? 'sent' : 'received'}`}
                            >
                              <div className="message-content">
                                {(() => {
                                  const tipo = String(msg.tipo_conteudo || '').toLowerCase();
                                  const isAudio = tipo === 'audio' || tipo.startsWith('audio/');
                                  const isImage = tipo === 'image' || tipo.startsWith('image/');
                                  const telegramMeta = msg?.metadados?.telegram || {};

                                  if (isAudio) {
                                    const transcription = String(
                                      msg.transcricao ||
                                      telegramMeta.transcription ||
                                      msg.conteudo ||
                                      ''
                                    ).trim();
                                    return (
                                      <div className="message-audio">
                                        <AppIcon name="mic" />
                                        <span>{transcription || 'Áudio'}</span>
                                      </div>
                                    );
                                  }

                                  if (isImage) {
                                    const caption = String(msg.conteudo || '').trim();
                                    const imageDescription = String(telegramMeta.image_description || '').trim();
                                    const shouldShowCaption = !!caption && (!imageDescription || caption !== imageDescription);

                                    return (
                                      <div className="message-image">
                                        {msg.url_midia && <img src={msg.url_midia} alt="Imagem" />}
                                        {shouldShowCaption && <p>{caption}</p>}
                                      </div>
                                    );
                                  }

                                  return <p>{msg.conteudo || '(sem conteúdo)'}</p>;
                                })()}
                                <span className="message-time">{formatTimestamp(msg.criado_em)}</span>
                              </div>
                            </div>
                          ))
                        )}
                      </div>

                      {detailMessages.length > 0 && (
                        <div className="messages-footer">
                          <small>Mostrando últimas {detailMessages.length} mensagens</small>
                        </div>
                      )}
                      <div className="messages-footer">
                        <button
                          className="btn-primary"
                          onClick={() => {
                            if (selectedConversation?.id) {
                              navigate(`/atendimentos?conversa_id=${selectedConversation.id}`);
                            } else if (detailConversations.length > 0) {
                              navigate(`/atendimentos?conversa_id=${detailConversations[0].id}`);
                            }
                            handleCloseDetailModal();
                          }}
                          disabled={!selectedConversation && detailConversations.length === 0}
                        >
                          <AppIcon name="chat" />
                          Ir para Conversa
                        </button>
                      </div>
                    </div>
                  )}

                  {activeTab === 'schedule' && (
                    <div className="tab-content schedule-tab">
                      <div className="schedule-section">
                        <div className="schedule-header">
                          <h3>Agendar Mensagem</h3>
                          <label className="toggle-label">
                            <input
                              type="checkbox"
                              checked={scheduleEnabled}
                              onChange={(e) => setScheduleEnabled(e.target.checked)}
                            />
                            <span className="toggle-slider"></span>
                            <span>Ativar agendamento</span>
                          </label>
                        </div>

                        <div className="schedule-form">
                          <div className="schedule-field">
                            <label>Data e hora</label>
                            <input
                              type="datetime-local"
                              value={scheduledDateTime}
                              onChange={(e) => setScheduledDateTime(e.target.value)}
                              disabled={!scheduleEnabled}
                            />
                          </div>

                          <div className="schedule-field">
                            <label>Mensagem</label>
                            <textarea
                              value={scheduledMessage}
                              onChange={(e) => setScheduledMessage(e.target.value)}
                              rows={4}
                              disabled={!scheduleEnabled}
                              placeholder="Digite a mensagem que sera enviada"
                            />
                          </div>

                          <div className="schedule-actions">
                            <button
                              className="btn-primary"
                              onClick={handleSaveSchedule}
                              disabled={!scheduleEnabled}
                            >
                              {editingScheduleId ? 'Atualizar' : 'Agendar'}
                            </button>
                            {editingScheduleId && (
                              <button
                                className="btn-secondary"
                                onClick={() => {
                                  setEditingScheduleId(null);
                                  setScheduledDateTime('');
                                  setScheduledMessage('');
                                }}
                              >
                                Cancelar edicao
                              </button>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="schedule-list-section">
                        <h3>Agendamentos</h3>
                        {scheduledLoading ? (
                          <div className="loading-state">Carregando...</div>
                        ) : scheduledEvents.length === 0 ? (
                          <div className="empty-state">
                            <AppIcon name="schedule" />
                            <p>Nenhum agendamento encontrado</p>
                          </div>
                        ) : (
                          <div className="schedule-list">
                            {scheduledEvents.map((event) => (
                              <div key={event.id} className="schedule-item">
                                <div className="schedule-info">
                                  <div className="schedule-date">{formatTimestamp(event.start_date)}</div>
                                  <div className="schedule-message">
                                    {event.custom_fields?.message_text || event.description || ''}
                                  </div>
                                  <div className={`schedule-status ${event.status || 'scheduled'}`}>
                                    {event.status || 'scheduled'}
                                  </div>
                                </div>
                                <div className="schedule-item-actions">
                                  <button
                                    className="btn-icon"
                                    onClick={() => handleEditSchedule(event)}
                                    title="Editar"
                                  >
                                    <AppIcon name="edit" />
                                  </button>
                                  {event.status !== 'canceled' && (
                                    <button
                                      className="btn-icon danger"
                                      onClick={() => handleCancelSchedule(event.id)}
                                      title="Cancelar"
                                    >
                                      <AppIcon name="delete" />
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {activeTab === 'projects' && (
                    <div className="tab-content projects-tab">
                      <div className="info-section">
                        <h3>Projetos com este contato</h3>
                        {projectsTabLoading ? (
                          <div className="loading-state">Carregando...</div>
                        ) : contactProjectCards.length === 0 ? (
                          <div className="empty-state">
                            <AppIcon name="folder_off" />
                            <p>Nenhum projeto encontrado para este contato</p>
                          </div>
                        ) : (
                          <div className="projects-list">
                            {contactProjectCards.map((cardItem) => {
                              const project = projectsMap[cardItem.project_id];
                              const list = listsMap[cardItem.list_id];
                              return (
                                <div key={cardItem.id} className="project-card-row">
                                  <div className="project-card-info">
                                    <div className="project-name">
                                      <AppIcon name="folder" />
                                      {project?.name || 'Projeto'}
                                    </div>
                                    <div className="project-card-meta">
                                      <span className="project-list">
                                        <AppIcon name={list?.icon || 'label'} style={{ color: list?.color || '#44e1ff' }} />
                                        {list?.name || 'Lista'}
                                      </span>
                                      <span className="project-card-status">{cardItem.status || 'ativo'}</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      <div className="info-section">
                        <h3>Gerenciar projetos</h3>
                        <div className="projects-actions">
                          <div className="form-field">
                            <label>Projeto</label>
                            <select
                              value={selectedProjectId}
                              onChange={(e) => setSelectedProjectId(e.target.value)}
                            >
                              <option value="">Selecione um projeto</option>
                              {availableProjects.map(project => (
                                <option key={project.id} value={project.id}>
                                  {project.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-field">
                            <label>Lista</label>
                            <select
                              value={selectedProjectListId}
                              onChange={(e) => setSelectedProjectListId(e.target.value)}
                              disabled={!selectedProjectId}
                            >
                              <option value="">Selecione uma lista</option>
                              {availableProjectLists.map(list => (
                                <option key={list.id} value={list.id}>
                                  {list.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="projects-action-buttons">
                            <button
                              className="btn-primary"
                              onClick={handleAddToProject}
                              disabled={projectsActionLoading}
                            >
                              <AppIcon name="add_circle" />
                              Adicionar ao projeto
                            </button>
                            <button
                              className="btn-secondary"
                              onClick={handleMoveToProject}
                              disabled={projectsActionLoading}
                            >
                              <AppIcon name="drive_file_move" />
                              Mover card atual
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === 'notes' && (
                    <div className="tab-content notes-tab">
                      <div className="info-section">
                        <h3>Observações do contato</h3>
                        <div className="schedule-form">
                          <div className="schedule-field">
                            <label>Observações</label>
                            <textarea
                              rows={6}
                              value={detailObservacoes}
                              onChange={(e) => setDetailObservacoes(e.target.value)}
                              placeholder="Adicione observações importantes sobre este contato"
                            />
                          </div>
                          <div className="schedule-actions">
                            <button
                              className="btn-primary"
                              onClick={handleSaveObservacoes}
                              disabled={savingObservacoes}
                            >
                              {savingObservacoes ? 'Salvando...' : 'Salvar observações'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === 'attachments' && (
                    <div className="tab-content attachments-tab">
                      <div className="info-section">
                        <h3>Anexos do contato</h3>
                        <div className="projects-actions">
                          <div className="form-field">
                            <label>Enviar arquivo</label>
                            <input
                              type="file"
                              onChange={handleUploadAttachment}
                              disabled={attachmentsUploading}
                            />
                          </div>
                          <div className="projects-action-buttons">
                            <button className="btn-secondary" onClick={loadContactAttachments}>
                              <AppIcon name="refresh" />
                              Atualizar
                            </button>
                          </div>
                        </div>
                        <small className="form-helper">Os anexos ficam salvos em storage privado (link assinado).</small>
                      </div>

                      <div className="info-section">
                        <h3>Arquivos</h3>
                        {attachmentsLoading ? (
                          <div className="loading-state">Carregando...</div>
                        ) : attachments.length === 0 ? (
                          <div className="empty-state">
                            <AppIcon name="attach_file" />
                            <p>Nenhum anexo adicionado ainda</p>
                          </div>
                        ) : (
                          <div className="schedule-list">
                            {attachments.map((item) => (
                              <div key={item.id} className="schedule-item">
                                <div className="schedule-info">
                                  <div className="schedule-date">{item.file_name}</div>
                                  <div className="schedule-message">
                                    {item.file_type || 'arquivo'} · {formatFileSize(item.file_size)}
                                  </div>
                                  <div className="schedule-status">
                                    {item.created_at ? formatTimestamp(item.created_at) : '-'}
                                  </div>
                                </div>
                                <div className="schedule-item-actions">
                                  <button
                                    className="btn-icon"
                                    onClick={() => handleRefreshAttachmentUrl(item.id)}
                                    title="Gerar link"
                                  >
                                    <AppIcon name="link" />
                                  </button>
                                  <a
                                    className="btn-icon"
                                    href={item.signedUrl || '#'}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={(e) => {
                                      if (!item.signedUrl) {
                                        e.preventDefault();
                                        handleRefreshAttachmentUrl(item.id);
                                      }
                                    }}
                                    title={item.signedUrl ? 'Abrir' : 'Gerar link'}
                                  >
                                    <AppIcon name="open_in_new" />
                                  </a>
                                  <button
                                    className="btn-icon danger"
                                    onClick={() => handleDeleteAttachment(item)}
                                    title="Remover"
                                  >
                                    <AppIcon name="delete" />
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn-primary"
                    onClick={() => {
                      if (selectedConversation?.id) {
                        navigate(`/atendimentos?conversa_id=${selectedConversation.id}`);
                      } else if (detailConversations.length > 0) {
                        navigate(`/atendimentos?conversa_id=${detailConversations[0].id}`);
                      }
                      handleCloseDetailModal();
                    }}
                    disabled={!selectedConversation && detailConversations.length === 0}
                  >
                    <AppIcon name="chat" />
                    Ir para Conversa
                  </button>

                  <button
                    className="btn-secondary"
                    onClick={() => {
                      setShowNewConversationModal(true);
                      setSelectedNewConnection(null);
                    }}
                  >
                    <AppIcon name="add_circle" />
                    Iniciar Nova Conversa
                  </button>

                  <button className="btn-secondary" onClick={handleCloseDetailModal}>
                    Fechar
                  </button>
                </div>

                {showNewConversationModal && (
                  <div className="modal-overlay" onClick={() => setShowNewConversationModal(false)}>
                    <div className="new-conversation-modal" onClick={(e) => e.stopPropagation()}>
                      <div className="modal-header-new">
                        <h3>Iniciar Nova Conversa</h3>
                        <button
                          className="btn-close-small"
                          onClick={() => setShowNewConversationModal(false)}
                        >
                          <AppIcon name="close" />
                        </button>
                      </div>

                      <div className="modal-body-new">
                        <label className="connection-label">Selecione uma conexão:</label>

                        {availableConnections.length === 0 ? (
                          <div className="empty-connections">
                            <AppIcon name="info" />
                            <p>Nenhuma outra conexão disponível</p>
                          </div>
                        ) : (
                          <select
                            className="connection-select"
                            value={selectedNewConnection?.id || ''}
                            onChange={(e) => {
                              const conn = availableConnections.find(c => c.id === e.target.value);
                              setSelectedNewConnection(conn);
                            }}
                          >
                            <option value="">-- Selecione uma conexão --</option>
                            {availableConnections.map(conn => (
                              <option key={conn.id} value={conn.id}>
                                {conn.name} ({conn.type})
                              </option>
                            ))}
                          </select>
                        )}
                      </div>

                      <div className="modal-footer-new">
                        <button
                          className="btn-primary"
                          onClick={handleStartNewConversation}
                          disabled={!selectedNewConnection || creatingConversation || availableConnections.length === 0}
                        >
                          <AppIcon name={creatingConversation ? 'progress_activity spinning' : 'arrow_forward'} />
                          {creatingConversation ? 'Criando...' : 'Ir'}
                        </button>
                        <button
                          className="btn-secondary"
                          onClick={() => setShowNewConversationModal(false)}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
      
      {/* Modal de Adicionar Contato */}
      {isAddModalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{isEditing ? 'Editar Contato' : 'Adicionar Novo Contato'}</h3>
              <button className="close-button" onClick={handleCloseModal}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                {/* Avatar do contato: imagem atual (se edição) ou iniciais */}
                {(() => {
                  const c = isEditing ? (contacts.find((x) => x.id === editingContactId) || {}) : {};
                  const currentSrc = c.image_url || c.image_url_preview || c.image_url_full || '';
                  const initials = getInitials(newContact.name || c.nome || c.name);
                  return (
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
                      <div style={{ width: 84, height: 84, borderRadius: '50%', overflow: 'hidden', background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(49,117,177,0.35)' }}>
                        {currentSrc ? (
                          <img src={currentSrc} alt="contato" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <span style={{ fontSize: 28, fontWeight: 600 }}>{initials}</span>
                        )}
                      </div>
                    </div>
                  );
                })()}
                {isEditing && ((() => {
                  const c = contacts.find((x) => x.id === editingContactId);
                  const currentSrc = c?.image_url || c?.image_url_preview || c?.image_url_full || '';
                  const suggestSrc = enrichedData?.image || enrichedData?.imagePreview || '';
                  return currentSrc || suggestSrc;
                })()) && (
                  <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
                    {(() => {
                      const c = contacts.find((x) => x.id === editingContactId);
                      const currentSrc = c?.image_url || c?.image_url_preview || c?.image_url_full || '';
                      if (!currentSrc) return null;
                      return (
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 4 }}>Atual</div>
                          <div style={{ width: 72, height: 72, borderRadius: '50%', overflow: 'hidden', background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img src={currentSrc} alt="contato" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          </div>
                        </div>
                      );
                    })()}
                    <span style={{ opacity: 0.6 }}>→</span>
                    {(() => {
                      const suggestSrc = enrichedData?.image || enrichedData?.imagePreview || '';
                      if (!suggestSrc) return null;
                      return (
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 4 }}>Sugestão</div>
                          <div style={{ width: 72, height: 72, borderRadius: '50%', overflow: 'hidden', background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img src={suggestSrc} alt="sugestão" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="name">Nome *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={newContact.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Digite o nome completo"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">E-mail</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={newContact.email}
                    onChange={handleInputChange}
                    placeholder="Digite o e-mail"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">WhatsApp *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={newContact.phone}
                    onChange={handleInputChange}
                    required
                    placeholder="(00) 00000-0000"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="tag">Tag</label>
                  <select id="tag" name="tag" value={newContact.tag} onChange={handleInputChange}>
                    <option value="Cliente">Cliente</option>
                    <option value="Fornecedor">Fornecedor</option>
                    <option value="Parceiro">Parceiro</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="cancel-button" onClick={handleCloseModal}>
                  Cancelar
                </button>
                <button type="submit" className="save-button">
                  {isEditing ? 'Salvar Alterações' : 'Salvar Contato'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      </>
      )}
    </div>
  );
};

export default ContactsPage;
